<template>
<div class="chapter">
<div class="inner_page">
<p class="tx"><br/><br/><br/><br/></p>
<p class="toch"><b>CONTENTS</b></p>
<p class="tx"><br/><br/><br/><br/></p>
<p class="toc" style="margin-top: 4em;"><a href="#/book1#fn1" id="en1"><i>Book One</i></a></p>
<hr/>
<p class="toc1"><a href="#/book1#fn1">THE MIDNIGHT READER</a></p>
<hr/>
<p class="toc"><a href="#/pastoral_care#fn2" id="en2">PASTORAL CARE</a></p>
<p class="toc"><span href="#/the_ravages#fn3" id="en3" title="Link target outside of Sample">THE RAVAGES OF SPRING</span></p>
<p class="toc"><span href="#/the_temptation#fn4" id="en4" title="Link target outside of Sample">THE TEMPTATION OF ST. IVO</span></p>
<p class="toc"><span href="#/the_warden#fn5" id="en5" title="Link target outside of Sample">THE WARDEN</span></p>
<p class="toc"><span href="#/john_napper#fn6" id="en6" title="Link target outside of Sample">JOHN NAPPER SAILING THROUGH THE UNIVERSE</span></p>
<p class="toc"><span href="#/book2#fn7" id="en7" title="Link target outside of Sample"><i>Book Two</i></span></p>
<hr/>
<p class="toc1"><span href="#/book2#fn7" title="Link target outside of Sample">TALES OF QUEEN LOUISA</span></p>
<hr/>
<p class="toc"><span href="#/queen_louisa#fn8" id="en8" title="Link target outside of Sample">QUEEN LOUISA</span></p>
<p class="toc"><span href="#/king_gregor#fn9" id="en9" title="Link target outside of Sample">KING GREGOR AND THE FOOL</span></p>
<p class="toc"><span href="#/muriel#fn10" id="en10" title="Link target outside of Sample">MURIEL</span></p>
<p class="toc"><span href="#/book3#fn11" id="en11" title="Link target outside of Sample"><i>Book Three</i></span></p>
<hr/>
<p class="toc1"><span href="#/book3#fn11" title="Link target outside of Sample">THE KING’S INDIAN</span></p>
<hr/>
<p class="toc"><span href="#/book3#fn12" id="en12" title="Link target outside of Sample"><i>A Tale</i></span></p>
<p class="toc"><span href="#/bio" id="bio" title="Link target outside of Sample"><i>A Biography of John Gardner</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6455ee4c